<ng-container [ngSwitch]="ctx.NavigationTemplate">
    <app-navigation-default [ctx]="ctx" *ngSwitchDefault></app-navigation-default>
</ng-container>